import Link from '@/lib/link'
import { ContentPage } from '@/components/content-page'

const faqs = [
  {
    q: 'Is NewChirp really free?',
    a: 'Yes. NewChirp is free of charge and open source under the GPL, just like the classic CHIRP project it is based on. There are no accounts, paywalls, or locked features.',
  },
  {
    q: 'How is NewChirp related to CHIRP?',
    a: 'NewChirp is a modern reimagining of the classic CHIRP programming software. It carries on the same open-source spirit and workflow while modernizing the experience. Rick Lopez leads development of NewChirp.',
  },
  {
    q: 'My radio is not detected. What do I do?',
    a: 'This is almost always a cable or driver problem. Confirm your programming cable shows up as a serial port in your operating system. Many inexpensive cables use a chipset that requires a specific driver, especially on Windows.',
  },
  {
    q: 'Which radios are supported?',
    a: 'NewChirp supports hundreds of models across dozens of manufacturers. Check the supported radios list on the home page, and if your model is missing you can request support.',
  },
  {
    q: 'Will NewChirp damage my radio?',
    a: 'Programming is a normal, supported operation. To be safe, always download and save a backup of your radio memory before uploading changes so you can restore the original state if needed.',
  },
  {
    q: 'What operating systems does it run on?',
    a: 'NewChirp runs on Windows 10 and 11, macOS (Intel and Apple Silicon), and Linux via Flatpak or from source.',
  },
]

export default function FaqPage() {
  return (
    <ContentPage
      eyebrow="// faq"
      title="Frequently Asked Questions"
      description="Quick answers to the questions we hear most. If your question isn't covered here, reach out and we'll help."
    >
      <div className="flex flex-col gap-4">
        {faqs.map((faq) => (
          <div key={faq.q} className="rounded-xl border border-border bg-card p-6">
            <h2 className="text-lg font-semibold text-foreground">{faq.q}</h2>
            <p className="mt-2 leading-relaxed text-muted-foreground">{faq.a}</p>
          </div>
        ))}
        <div className="mt-4 rounded-xl border border-primary/30 bg-primary/5 p-6">
          <p className="leading-relaxed text-muted-foreground">
            Still stuck? Head to the{' '}
            <Link href="/support" className="text-primary underline underline-offset-4">
              support page
            </Link>{' '}
            to report an issue, or read the{' '}
            <Link href="/docs" className="text-primary underline underline-offset-4">
              documentation
            </Link>
            .
          </p>
        </div>
      </div>
    </ContentPage>
  )
}
